import React from 'react';
import { Button } from 'reactstrap';

export const ListItem = ({ domain, handleSwitchStatus }) => (
    <tr>
        <td
            data-label="ID"
            className="alert-list-td"
        >
            {domain.id}
        </td>
        <td
            data-label="Name"
            className="alert-list-td"
        >
            {domain.domain}
        </td>
        <td data-label="Actions">
            <div className="responsive-table__edit-block">
                <Button
                    color="light"
                    onClick={() => handleSwitchStatus(domain)}
                >
                    <i className={domain.is_active ? "fa fa-pause fa-lg" : "fa fa-play fa-lg"}/>
                </Button>
            </div>
        </td>
    </tr>
);

